import { supabase } from '@/lib/supabaseClient';

export const requireSuperAdmin = async (): Promise<boolean> => {
  const { data: sessionData } = await supabase.auth.getSession();
  if (!sessionData.session) return false;

  const { data } = await supabase
    .from('saas_super_admins')
    .select('id')
    .eq('user_id', sessionData.session.user.id)
    .maybeSingle();

  return !!data;
};
